// Strings commented out are pending official translations

import arEG from '/druid/ar-EG.json';
import arJO from '/druid/ar-JO.json';
import arSA from '/druid/ar-SA.json';
import bgBG from '/druid/bg-BG.json';
import caES from '/druid/ca-ES.json';
import csCZ from '/druid/cs-CZ.json';
import daDK from '/druid/da-DK.json';
import deDE from '/druid/de-DE.json';
import elGR from '/druid/el-GR.json';
import enUS from '/druid/en-US.json';
import esES from '/druid/es-ES.json';
import etEE from '/druid/et-EE.json';
import euES from '/druid/eu-ES.json';
import fiFI from '/druid/fi-FI.json';
import frFR from '/druid/fr-FR.json';
import glES from '/druid/gl-ES.json';
import heIL from '/druid/he-IL.json';
import hiIN from '/druid/hi-IN.json';
import hrHR from '/druid/hr-HR.json';
import huHU from '/druid/hu-HU.json';
import idID from '/druid/id-ID.json';
import itIT from '/druid/it-IT.json';
import jaJP from '/druid/ja-JP.json';
import kkKZ from '/druid/kk-KZ.json';
import koKR from '/druid/ko-KR.json';
import ltLT from '/druid/lt-LT.json';
import lvLV from '/druid/lv-LV.json';
import msMY from '/druid/ms-MY.json';
import nbNO from '/druid/nb-NO.json';
import nlNL from '/druid/nl-NL.json';
import plPL from '/druid/pl-PL.json';
import ptBR from '/druid/pt-BR.json';
import ptPT from '/druid/pt-PT.json';
import roRO from '/druid/ro-RO.json';
import ruRU from '/druid/ru-RU.json';
import skSK from '/druid/sk-SK.json';
import slSI from '/druid/sl-SI.json';
import srCyrlCS from '/druid/sr-Cyrl-CS.json';
import srLatnCS from '/druid/sr-Latn-CS.json';
import svSE from '/druid/sv-SE.json';
import thTH from '/druid/th-TH.json';
import trTR from '/druid/tr-TR.json';
import ukUA from '/druid/uk-UA.json';
import viVN from '/druid/vi-VN.json';
import yue from '/druid/yue.json';
import zhCN from '/druid/zh-CN.json';
import zhHK from '/druid/zh-HK.json';
import zhTW from '/druid/zh-TW.json';

import bundledOverrides from '/druid/overrides.json';
import LocalizedStrings from './druid/types/LocalizedStrings';
import mergeLocalizedStrings from '/druid/mergeLocalizedStrings';

let localizedStrings;

function getAllLocalizedStrings(): { [language: string]: LocalizedStrings } {
  return (
    localizedStrings ||
    (localizedStrings = mergeLocalizedStrings(
      {
        'ar-EG': arEG,
        'ar-JO': arJO,
        'ar-SA': arSA,
        'bg-BG': bgBG,
        'ca-ES': caES,
        'cs-CZ': csCZ,
        'da-DK': daDK,
        'de-DE': deDE,
        'el-GR': elGR,
        'en-US': enUS,
        'es-ES': esES,
        'et-EE': etEE,
        'eu-ES': euES,
        'fi-FI': fiFI,
        'fr-FR': frFR,
        'gl-ES': glES,
        'he-IL': heIL,
        'hi-IN': hiIN,
        'hr-HR': hrHR,
        'hu-HU': huHU,
        'id-ID': idID,
        'it-IT': itIT,
        'ja-JP': jaJP,
        'kk-KZ': kkKZ,
        'ko-KR': koKR,
        'lt-LT': ltLT,
        'lv-LV': lvLV,
        'ms-MY': msMY,
        'nb-NO': nbNO,
        'nl-NL': nlNL,
        'pl-PL': plPL,
        'pt-BR': ptBR,
        'pt-PT': ptPT,
        'ro-RO': roRO,
        'ru-RU': ruRU,
        'sk-SK': skSK,
        'sl-SI': slSI,
        'sr-Cyrl': srCyrlCS,
        'sr-Latn': srLatnCS,
        'sv-SE': svSE,
        'th-TH': thTH,
        'tr-TR': trTR,
        'uk-UA': ukUA,
        'vi-VN': viVN,
        yue,
        'zh-Hans': zhCN,
        'zh-Hant': zhTW,
        'zh-Hans-SG': zhCN,
        'zh-Hant-HK': zhHK,
        'zh-Hant-MO': zhTW
      },
      bundledOverrides
    ))
  );
}

export default getAllLocalizedStrings;
